import React, { HTMLAttributes } from 'react';

import { style } from 'typestyle';
import { ADALONG_COLORS } from '@src/styles';

interface IProps extends HTMLAttributes<HTMLDivElement> {
  containerClasses?: string[];
  frameClasses?: string[];
  onClose: any;
}

export function OverlayContainer({
  containerClasses = [],
  frameClasses = [],
  onClose,
  style: styleProp,
  onClick,
  children,
  ...props
}: IProps) {
  // Extract z-index from style to apply to container if provided
  const containerStyle = styleProp?.zIndex ? { zIndex: styleProp.zIndex } : {};
  const frameStyle = styleProp?.zIndex ? { ...styleProp } : styleProp;

  function handleClick(e: React.MouseEvent<HTMLDivElement, MouseEvent>) {
    e.stopPropagation();
    if (onClick) {
      onClick(e);
    }
  }

  return (
    <div 
      className={[containerClass, ...containerClasses].join(' ')} 
      onClick={onClose}
      style={containerStyle}
    >
      <div
        className={[frameClass, ...frameClasses].join(' ')}
        {...props}
        style={frameStyle}
        onClick={handleClick}
      >
        {children}
      </div>
    </div>
  );
}

const containerClass = style({
  position: 'fixed',
  width: '100%',
  height: '100%',
  top: 0,
  left: 0,
  zIndex: 4,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  background: 'rgba(0, 0, 0, 0.6)', 
  backdropFilter: 'blur(4px)',
});

const frameClass = style({
  maxHeight: '90%',
  maxWidth: '95%',
  margin: 'auto',
  fontFamily: '"Public Sans", sans-serif',
  overflow: 'hidden',
  position: 'relative',
  background: ADALONG_COLORS.SMOOTH_BLACK,
  padding: '24px', 
  borderRadius: '16px', 
  boxShadow: '0 20px 60px rgba(0, 0, 0, 0.4), 0 8px 16px rgba(0, 0, 0, 0.2)', 
  border: '1px solid rgba(255, 255, 255, 0.1)',
  $nest: {
    i: {
      fontSize: 19,
    },
    '@media (prefers-reduced-motion: no-preference)': {
      animation: 'fadeInScale 0.25s ease-out',
    },
  },
});

// Keyframes for the animation
const keyframes = `
  @keyframes fadeInScale {
    from {
      opacity: 0;
      transform: scale(0.9) translateY(20px);
    }
    to {
      opacity: 1;
      transform: scale(1) translateY(0);
    }
  }
`;

// Inject keyframes into the document
if (typeof document !== 'undefined' && !document.querySelector('#overlay-animations')) {
  const styleElement = document.createElement('style');
  styleElement.id = 'overlay-animations';
  styleElement.textContent = keyframes;
  document.head.appendChild(styleElement);
}
